import React, { useState, useEffect, useRef } from 'react';
import { Icon } from '@iconify/react';

const Searchbox = ({ placeholder = "Search...", onSearch, delay = 300 }) => {
  const [value, setValue] = useState("");

  // Keep the latest callback in a ref so a non-memoized `onSearch` prop
  // doesn't restart the debounce timer on every parent re-render.
  const onSearchRef = useRef(onSearch);
  useEffect(() => {
    onSearchRef.current = onSearch;
  }, [onSearch]);

  const isFirstRun = useRef(true);

  useEffect(() => {
    // Don't fire an empty search on mount — the list already loads by default.
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    const timer = setTimeout(() => {
      if (typeof onSearchRef.current === "function") {
        onSearchRef.current(value);
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return (
    <div className="relative w-full">
      <Icon 
        icon="mdi:magnify" 
        className="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary text-xl pointer-events-none" 
      />
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        className="w-full pl-10 pr-4 py-3 border border-border-light rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary bg-white text-text-dark"
      />
      {value && (
        <button
          onClick={() => setValue("")}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-text-secondary hover:text-text-dark"
        >
          <Icon icon="mdi:close" className="text-lg" />
        </button>
      )}
    </div>
  );
};

export default Searchbox;
